import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function NotificationForm({notification, open, setOpen}) {

  const [title, setTitle] = useState(notification?.title ?? "")
  const [description, setDescription] = useState(notification?.description ?? "")
  const [createDate, setCreateDate] = useState(notification?.create_date ?? "")

  useEffect(() => {
    setTitle(notification?.title ?? "")
    setDescription(notification?.description ?? "")
    setCreateDate(notification?.create_date ?? "")
  }, [notification]);

  const handleOpen = () => setOpen(!open);


  return (
    <>
      <Dialog open={open} handler={handleOpen} size="xl"
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>مشاهده پیام</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`عنوان: ${title}`}
            </Typography>
          </div>

          <div className="mb-4 border-b">
            <Typography color="blue-gray">
              {`متن پیام: ${description}`}
            </Typography>
          </div>

          <div className="mb-4">
            <Typography color="blue-gray">
              {`زمان ارسال: ${persianNumberFormat(createDate.split(" ")[1] + " " + createDate.split(" ")[0])}`}
            </Typography>
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>بستن</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}